(function(){
  function initDynamicIslandMadScroll(){
    // Only run if your helper exists
    if (typeof window.madScrollTo !== 'function') return;

    var links = document.querySelectorAll('.nb-dynamic-island__link[href^="#"]');
    if (!links.length) return;

    links.forEach(function(link){
      // Capture phase so we run before NextBricks' own click handler
      link.addEventListener('click', function(e){
        var href = link.getAttribute('href');
        if (!href || href === '#' || href === '#!') return;

        e.preventDefault();
        e.stopImmediatePropagation();

        // Smooth scroll using your global helper
        window.madScrollTo(href, 'default', function(){
          // Optional: update hash in URL after scroll
          try {
            if (history.pushState) {
              history.pushState(null, '', href);
            } else {
              window.location.hash = href;
            }
          } catch(_){}
        });

        // Close the island via overlay click so GSAP reverse still works
        var island = link.closest('.nb-dynamic-island');
        if (island) {
          var overlay = island.querySelector('.nb-dynamic-island__overlay');
          if (overlay) {
            overlay.click();
          }
        }
      }, true); // <- capture = true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDynamicIslandMadScroll);
  } else {
    initDynamicIslandMadScroll();
  }
})();
